import classNames from 'classnames';
import * as React from 'react';
import { usePlannerContext } from '../Planner/Context/PlannerContextProvider';
import { usePlannerTranslations } from '../Planner/Context/PlannerTranslationsContextProvider';
import { BookmarkContainer } from '~/Partials/BookmarkContainer/BookmarkContainer';
import type { TabKey } from '~/Partials/TabList/Tab';
import styles from './PlannerBookmarks.module.css';

interface PlannerBookmarksProps {
    className?: string;
}

export const PlannerBookmarks: React.FC<React.PropsWithChildren<PlannerBookmarksProps>> = props => {
    const { className, children } = props;

    const { bookmarks, currentBookmark, setCurrentBookmark } = usePlannerContext();
    const { selectTab } = usePlannerTranslations();

    const handleBookmarkSelection = (tabKey: TabKey) => {
        const foundBookmark = bookmarks.find(bookmark => bookmark.uniqueId === tabKey);

        if (foundBookmark) {
            setCurrentBookmark(foundBookmark);
        }
    };

    return (
        <BookmarkContainer
            className={classNames(styles.PlannerBookmarks, className)}
            contentClassName={styles.BookmarkContainerContent}
            tabs={bookmarks}
            currentlySelectedTab={currentBookmark.uniqueId}
            setSelectedTab={handleBookmarkSelection}
            tabsLabel={selectTab}
            variant="light"
        >
            {children}
        </BookmarkContainer>
    );
};
